import React from "react";
import { motion } from "framer-motion";
import { HOME } from "@/constants/testIds";

const CHAPTERS = [
  {
    n: "I",
    title: "Silence is a weapon.",
    body: "We do not shout. We do not stream. We rise before the sun and refuse the algorithm. The work speaks — years later, in the shape of a body, in the ring of a voice.",
  },
  {
    n: "II",
    title: "The body is a temple you built.",
    body: "Iron, breath, cold water. The tools are ancient because they still work. We do not chase novelty. We chase permanence.",
  },
  {
    n: "III",
    title: "Discipline is inherited.",
    body: "Every rep is a signature you leave for the person you are becoming. Sign carefully. Sign daily. Sign in silver.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="about"
      data-testid={HOME.manifesto}
      className="relative bg-black text-white py-32 md:py-44 overflow-hidden"
    >
      {/* Silver wash backdrop (static) */}
      <div className="absolute inset-x-0 top-0 h-[120%] pointer-events-none">
        <div className="absolute left-1/2 top-1/3 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(200,205,215,0.10)_0%,transparent_60%)]" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="flex items-baseline justify-between mb-16 md:mb-24 border-b border-white/10 pb-8"
        >
          <div>
            <div className="font-mono text-[10px] tracking-[0.42em] text-silver-300 mb-3">
              §01 — THE CREED
            </div>
            <h2 className="font-serif italic text-[8vw] md:text-[5.5vw] lg:text-[4.6vw] leading-[0.95] tracking-[-0.02em] text-white">
              Three chapters,
              <br />
              <span className="not-italic text-silver-100">one covenant.</span>
            </h2>
          </div>
          <div className="hidden md:block text-right font-mono text-[10px] tracking-[0.35em] text-silver-300/70">
            READ TIME — 90 SEC
          </div>
        </motion.div>

        <div className="space-y-24 md:space-y-28">
          {CHAPTERS.map((ch, i) => (
            <motion.article
              key={ch.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{
                duration: 0.9,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="grid grid-cols-12 gap-6 md:gap-12 items-start"
            >
              <div className="col-span-12 md:col-span-2 flex md:block items-baseline gap-3">
                <div className="font-serif italic text-silver-200 text-[64px] md:text-[92px] leading-none">
                  {ch.n}
                </div>
                <div className="md:mt-2 font-mono text-[10px] tracking-[0.35em] text-silver-300/60">
                  CHAPTER
                </div>
              </div>
              <div className="col-span-12 md:col-span-6">
                <h3 className="font-serif text-white text-[7vw] md:text-[3vw] leading-[1.02] tracking-[-0.01em]">
                  {ch.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-4 md:pt-4">
                <p className="text-white/70 leading-[1.75] text-[15px]">
                  {ch.body}
                </p>
                <div className="mt-6 h-px w-16 bg-silver-300" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
